import { Link } from "react-router-dom";
import { FaRegCopy, FaRegCheckCircle } from "react-icons/fa";
import {
  EthTokenIcon,
  BscTokenIcon,
  SolTokenIcon,
  AvaxTokenIcon,
  PolygonTokenIcon,
  ArbitrumTokenIcon,
} from "./tokens/svgs";
import { useState } from "react";

function AbbreviateAddress({ address, network }) {
  const abbreviate = (address) => {
    if (address.length <= 10) return address;
    const prefix = address.substring(0, 6);
    const suffix = address.substring(address.length - 6);
    return `${prefix}...${suffix}`;
  };
  const copyButton = <FaRegCopy />;
  const successCopy = <FaRegCheckCircle />;
  const [buttonReg, setButtonReg] = useState(copyButton);

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(address)
      .then(() => {
        console.log("Address copied to clipboard");
        setButtonReg(successCopy);
        setTimeout(() => {
          setButtonReg(copyButton);
        }, 1000); // Change back to copyButton after 2 seconds
      })
      .catch((error) => {
        console.error("Failed to copy address to clipboard:", error);
      });
  };

  // Define the target link based on the network
  let targetLink;
  switch (network) {
    case 56:
      targetLink = `https://bscscan.com/token/${address}`;
      break;
    case 1:
      targetLink = `https://etherscan.io/token/${address}`;
      break;
    case 69:
      targetLink = `https://solscan.io/token/${address}`;
      break;
    case 43114:
      targetLink = `https://snowtrace.io/token/${address}`;
      break;
    case 137:
      targetLink = `https://polygonscan.com/token/${address}`;
      break;
    case 42161:
      targetLink = `https://arbiscan.io/token/${address}`;
      break;
    default:
      targetLink = "/";
  }
  return (
    <div class="flex items-center gap-1 truncate rounded px-1 py-0.5 font-semibold capitalize bg-neutral-10 text-neutral-100 dark:bg-neutral-90 dark:text-neutral-0 text-xs">
      <div class="flex w-full items-center justify-between gap-1">
        <Link to={targetLink} target="_blank" class="flex items-center gap-1">
          <div class="overflow-hidden rounded">
            {network === 56 ? (
              <BscTokenIcon size={14} />
            ) : network === 1 ? (
              <EthTokenIcon size={14} />
            ) : network === 69 ? (
              <SolTokenIcon size={14} />
            ) : network === 43114 ? (
              <AvaxTokenIcon size={14} />
            ) : network === 137 ? (
              <PolygonTokenIcon size={14} />
            ) : network === 42161 ? (
              <ArbitrumTokenIcon size={14} />
            ) : null}
          </div>
          <div class="text-xs font-medium">{abbreviate(address)}</div>
        </Link>
        <div className="flex cursor-pointer items-center text-neutral-50">
          <button aria-label="Copy" type="button" onClick={copyToClipboard}>
            <div data-projection-id="84" style={{ opacity: 1 }}>
              {buttonReg}
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}

export default AbbreviateAddress;
